import { Button } from '@material-ui/core';
import currencyFormatter from 'currency-formatter';
import { WithStyles } from 'decorators/withStyles';
import { IProductOrderBump } from 'interfaces/orderbump';
import React, { PureComponent } from 'react';

import ListProductSelection from './ListProductSelection';

interface IProps {
  classes?: any;
  productsList?: IProductOrderBump[];
  handleSubmit?: (productSelected: IProductOrderBump) => void;
  buttonText: string;
  productSelected?: IProductOrderBump;
}

interface IState {
  showAlert: boolean;
  isLoading: boolean;
  openList: boolean;
}

@WithStyles(theme => ({
  orderBumpSelect: {
    width: '425px',
    display: 'flex',
    flexFlow: 'wrap',
    height: '140px'
  },
  imagemProduct: {
    border: '1px dashed #979797',
    borderRadius: '4px',
    height: '81px',
    width: '81px',
    '& img': {
      width: '100%',
      height: '100%'
    }
  },
  descriptionProduct: {
    height: '81px',
    width: '336px',
    border: '1px dashed #979797',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    marginLeft: '8px',
    '& p': {
      margin: 0
    }
  },
  title: {
    color: '#596375'
  },
  price: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#009358'
  },
  buttonPrincipal: {
    backgroundColor: theme.variables.colors['primaryColor'],
    color: '#FFF',
    fontWeight: 'bold',
    height: '40px',
    letterSpacing: '0.5px',
    width: '290px'
  }
}))
export default class SelectProduct extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { showAlert: false, isLoading: false, openList: false };
  }

  openList = () => {
    this.setState({ openList: true });
  };

  closeList = () => {
    this.setState({ openList: false });
  };

  onSubmit = (productSelected: IProductOrderBump) => {
    this.props.handleSubmit(productSelected);
  };

  render() {
    const { classes, productsList, buttonText, productSelected } = this.props;
    const { openList } = this.state;
    if (!productsList) return null;

    return !productSelected ? (
      <div className={classes.orderBumpSelect}>
        <div className={classes.imagemProduct}></div>
        <div className={classes.descriptionProduct}></div>
        <Button onClick={this.openList} className={classes.buttonPrincipal}>
          {buttonText}
        </Button>
        <ListProductSelection
          open={openList}
          products={productsList}
          onClose={this.closeList}
          onSubmit={this.onSubmit}
        />
      </div>
    ) : (
      <div className={classes.orderBumpSelect}>
        <div style={{ border: 'none' }} className={classes.imagemProduct}>
          <img src={productSelected.image} />
        </div>
        <div style={{ border: 'none' }} className={classes.descriptionProduct}>
          <p className={classes.title}>{`${productSelected.id} - ${productSelected.title}`}</p>
          <p className={classes.price}>
            {currencyFormatter.format(productSelected.price, { code: 'BRL', precision: 2 })}
          </p>
        </div>
        <Button onClick={this.openList} className={classes.buttonPrincipal}>
          {buttonText}
        </Button>
        <ListProductSelection
          open={openList}
          products={productsList}
          onClose={this.closeList}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}
